define('sentient/aba/views/WindowCanvasView',[
    'jquery',
    'underscore',
    'backbone',
    'loglevel'
], function($, _, Backbone, log, TouchCollection) {
    log.trace('WindowCanvasView.js');
    var WindowCanvasView = Backbone.View.extend({
        el: document,
        initialize: function() {
            this.updateScreenResolution();
            //log.debug('WindowCanvasView::resolution', this.resolution);


            if (typeof this.canvas == 'undefined') {
                this.canvas = document.createElement('CANVAS');
                this.$canvas = $(this.canvas);

                this.$canvas.css({
                    'width': '100%',
                    'height': '100%',
                    'position': 'absolute',
                    'top': 0,
                    'left': 0,
                    'z-index': 100,
                    'pointer-events': 'none'
                });
            }
            this.$('body').append(this.$canvas);
            this.$canvas.attr({
                width: this.$canvas.width(),
                height: this.$canvas.height()
            });
            //log.debug("WindowCanvasView::initialize",this);
        },
        updateScreenResolution: function() {
            var measureDiv = $(document.createElement('div')).css({
                width: '1cm',
                height: '1cm',
                position: 'absolute',
                top: 0,
                left: 0
            });
            this.$('body').append(measureDiv);
            this.resolution = {
                'horizontal': {
                    'px/cm': measureDiv.width()
                },
                'vertical': {
                    'px/cm': measureDiv.height()
                }
            };
            measureDiv.remove();
        },
        drawTouchCircle: function(x, y, r) {
            var ctx = this.canvas.getContext('2d');
            if (typeof x == 'undefined' && typeof y == 'undefined') {
                ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            }
            r = r || 1;
            //ctx.clearRect(0,0,this.canvas.width,this.canvas.height);
            ctx.fillStyle = 'rgba(255,255,255,0.5)';
            ctx.beginPath();
            ctx.arc(x, y, this.resolution['horizontal']['px/cm'] * r, 0, 2 * Math.PI);
            ctx.fill();
        },
        resize: function() {
            this.$canvas.attr({
                width: this.$canvas.width(),
                height: this.$canvas.height()
            });
            this.updateScreenResolution();
        }
    });
    return WindowCanvasView;
});
